<template>
  <div @click="onSlotClick">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { KlevuEvents } from "@klevu/core";
import type { Breadcrumb, ProductShort } from "~/types";

const { productLink } = useCatalogLinker();

const props = defineProps<{
  product: ProductShort;
  categoryTitle: string;
  breadcrumbs: Breadcrumb[];
  productPosition?: number;
  position?: number;
}>();

function onSlotClick(): void {
  if (props.product._klevu_id) {
    KlevuEvents.categoryMerchandisingProductClick({
      categoryTitle: props.categoryTitle,
      productPosition: props.position,
      klevuCategory: props.breadcrumbs.map((c) => c.label).join(";") ?? [],

      product: {
        id: props.product._klevu_id,
        name: props.product.name,
        url: productLink(props.product, { withDomain: true }),
      },
    });
  } else {
    console.warn(`_klevu_id is empty, klevu event was not sent`);
  }
}
</script>
